exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-tooltip-lite{\r\n    z-index: 100000 !important;\r\n}", ""]);

// exports
